function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Space, Alert, Modal } from "antd";
import Common from "../includes/Common";
import { PenFill, ArrowClockwise } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;
var UpdateCustomer = function UpdateCustomer(_ref) {
  var customer = _ref.customer,
    handler = _ref.handler;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    createdValues = _useState8[0],
    setCreatedValues = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    pmOptions = _useState10[0],
    setPmOptions = _useState10[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isResetLoading = _useState12[0],
    setIsResetLoading = _useState12[1];
  var edit = function edit(values) {
    setIsFormLoading(true);
    setErrorMessage("");
    setSuccessMessage("");
    var formData = new FormData();
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);
    formData.append('paymentmethod', values.paymentmethod);
    formData.append('mobile', values.mobile);
    formData.append('rnc', values.rnc);
    formData.append("id", customer.id);
    formData.append("uid", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'editcustomer', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        setCreatedValues(values);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
      window.scroll({
        top: 0,
        behavior: 'smooth'
      });
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      lastname: customer.lastname,
      firstname: customer.firstname,
      rnc: customer.rnc,
      paymentmethod: parseInt(customer.paymentmethod),
      mobile: customer.mobile
    });
  }, [customer]);
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getactivepaymenttypes/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        response.data.paymentTypes.forEach(function (p) {
          setPmOptions(function (old) {
            return [].concat(_toConsumableArray(old), [{
              label: p.label,
              value: p.id
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue, contactez l'administrateur",
        delay: 4
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: successMessage,
      type: "success",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: edit,
      form: form,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "rnc",
        label: "RNC",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "firstname",
        label: "Pr\xE9nom",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "lastname",
        label: "Nom",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "mobile",
        label: "T\xE9l\xE9phone",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "paymentmethod",
        label: "Moyen de paiement",
        rules: [{
          required: true,
          message: 'Choisir le moyen de paiement'
        }],
        children: /*#__PURE__*/_jsx(Select, {
          showSearch: true,
          defaultValue: 1,
          options: pmOptions
        })
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "submit",
          children: /*#__PURE__*/_jsx(Button, {
            type: "primary",
            loading: isFormLoading,
            disabled: pmOptions.length == 0,
            htmlType: "submit",
            icon: /*#__PURE__*/_jsx(PenFill, {
              size: 24
            }),
            children: "Modifier"
          })
        }), /*#__PURE__*/_jsxs(Form.Item, {
          children: [contextHolder, /*#__PURE__*/_jsx(Button, {
            type: "link",
            loading: isResetLoading,
            icon: /*#__PURE__*/_jsx(ArrowClockwise, {
              size: 24
            }),
            onClick: function onClick() {
              setIsResetLoading(true);
              confirm({
                title: /*#__PURE__*/_jsx("b", {
                  children: "Confirmez-vous ?"
                }),
                content: /*#__PURE__*/_jsxs("p", {
                  children: ["L'actualisation du candidat ayant le RNC ", customer.rnc, " pour le traitement."]
                }),
                cancelText: "Annuler",
                onCancel: function onCancel() {
                  setIsResetLoading(false);
                },
                onOk: function onOk() {
                  var formData = new FormData();
                  formData.append('uid', Common.currentUser.id);
                  formData.append('rnc', customer.rnc);
                  formData.append("id", customer.id);
                  axios.post(Common.baseApiUrl + 'reset', formData).then(function (response) {
                    if (response.data.status == 200) {
                      setSuccessMessage(response.data.message);
                    } else {
                      setErrorMessage(response.data.message);
                    }
                  })["catch"](function (error) {
                    setErrorMessage('Une erreur est survenue');
                  })["finally"](function () {
                    setIsResetLoading(false);
                    window.scroll({
                      top: 0,
                      behavior: 'smooth'
                    });
                  });
                }
              });
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "ACTUALISER"
            })
          })]
        })]
      })]
    })]
  });
};
export default UpdateCustomer;